// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iS","advertCardNum":"c-a_iT"};